import Model from './Model';

export default class NewsRecord extends Model {
  resource() {
    return 'news-records';
  }
}
